<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="4">
				<el-date-picker style="width: 100%;" v-model="searchInfo.begintime" type="date"
					placeholder="选择开始日期"></el-date-picker>
			</el-col>
			<el-col :span="4">
				<el-date-picker style="width: 100%;" v-model="searchInfo.endtime" type="date"
					placeholder="选择结束日期"></el-date-picker>
			</el-col>
			<el-col :span="4">
				<el-select clearable style="width: 100%;" v-model="searchInfo.timevalue" filterable placeholder="请选择时间">
					<el-option v-for="item in timeList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</el-col>
			<el-col :span="8">
				<el-button type="primary" @click="searchData" icon="el-icon-search">搜索</el-button>
				<el-button icon="el-icon-refresh" @click="clearSearch">重置</el-button>
				<el-button type="primary" icon="el-icon-tickets" @click="exportOrders">导出明细</el-button>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-row>
				<el-col :span="12">
					<span style="color: #000;font-size: 15px;">
						日期：{{ this.statinfo.begintime }} 至 {{ this.statinfo.endtime }}
					</span>
				</el-col>
			</el-row>
			<el-row style="margin-top: 5px;">
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						订单总计：{{ this.statinfo.order_count }}单
					</span>
				</el-col>
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						退单数量：{{ this.statinfo.refund_count }}单
					</span>
				</el-col>
				<el-col :span="13">
					<span style="color: #000;font-size: 15px;">
						热卖商品：{{ this.statinfo.hot_sale_foods }}
					</span>
				</el-col>
			</el-row>
			<el-row style="margin-top: 5px;">
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						使用平台优惠券：{{ this.statinfo.coupon_count }}张
					</span>
				</el-col>
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						优惠金额：{{ this.statinfo.coupon_value }}元
					</span>
				</el-col>
			</el-row>
			<el-row style="margin-top: 5px;">
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						平台应售总额：{{ this.statinfo.total_platform_amount }}元
					</span>
				</el-col>
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						商家应售总额：{{ this.statinfo.total_business_amount }}元
					</span>
				</el-col>
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						商家退款总额：{{ this.statinfo.total_business_refund_amount }}元
					</span>
				</el-col>
				<el-col :span="10">
					<span style="color: #000;font-size: 15px;">
						<label title="平台扣除=(商家应售总额-商家退款)*抽成比例">平台扣除：</label>({{ (this.statinfo.platform_deduction_ratio * 100).toFixed(0) }}%)：{{
							this.statinfo.platform_deduction }}元
					</span>
				</el-col>
			</el-row>
			<!-- <el-row style="margin-top: 5px;">
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						<label title="商品应售金额-平台扣除">需付商家金额：</label>{{ this.statinfo.total_stallpayamount }}元
					</span>
				</el-col>
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						<label title="平台应售总额-商家应售总额">平台差价：</label>{{ this.statinfo.total_platformdiff }}元
					</span>
				</el-col>
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						<label title="平台应售总额-优惠金额-平台退款">结算金额：</label>{{ this.statinfo.total_settlementamount }}元
					</span>
				</el-col>
			</el-row> -->
			<el-row style="margin-top: 5px;">
				<el-col :span="5" v-show="this.statinfo.is_wechat_deduction">
					<span style="color: #000;font-size: 15px;">
						微信支付总额：{{ this.statinfo.total_payed_amount }}元
					</span>
				</el-col>
				<el-col :span="5" v-show="this.statinfo.is_wechat_deduction">
					<span style="color: #000;font-size: 15px;">
						微信扣除({{ (this.statinfo.wechat_deduction_ratio * 100).toFixed(1) }}%)：{{
							this.statinfo.wechat_deduction }}元
					</span>
				</el-col>
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						平台退款总额：{{ this.statinfo.total_platform_refund_amount }}元
					</span>
				</el-col>
			</el-row>
			<el-row style="margin-top: 5px;">
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						打包费：{{ this.statinfo.total_packprice }}元
					</span>
				</el-col>
				<el-col :span="5" v-show="this.statinfo.is_wechat_deduction">
					<span style="color: #000;font-size: 15px;">
						配送费：{{ this.statinfo.total_delivery_fee }}元
					</span>
				</el-col>
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						开柜费：{{ this.statinfo.total_open_cabinet_fee }}元
					</span>
				</el-col>
			</el-row>
			<el-row style="margin-top: 5px;">
				<el-col :span="5">
					<span style="color: #000;font-size: 15px;">
						<label title="平台收入合计=平台应售总额-商家应售总额-配送费-开柜费-优惠券金额-微信扣除-平台退款+平台扣除">平台收入合计：</label>{{
							this.statinfo.total_income }}元
					</span>
				</el-col>
			</el-row>
		</div>
		<div style="margin-top: 10px;">
			<el-table :data="recordList" style="width: 100%" height="700">
				<el-table-column fixed="left" prop="ordertime" label="下单时间" width="100" align="center"></el-table-column>
				<el-table-column prop="orderno" label="订单号" width="180" align="center"></el-table-column>
				<el-table-column prop="foodname" label="商品名称" width="160" align="center"></el-table-column>
				<el-table-column prop="platform_offprice" label="平台优惠价(含打包费)" width="120"
					align="center"></el-table-column>
				<el-table-column prop="isrefund" label="是否退款" width="80" align="center"></el-table-column>
				<el-table-column prop="refundreason" label="退款原因" width="120" align="center"></el-table-column>
				<el-table-column prop="refundtime" label="退款日期" width="100" align="center"></el-table-column>
				<el-table-column prop="refundamount" label="退款金额" width="100" align="center"></el-table-column>
				<el-table-column prop="coupon_category" label="优惠券种类" width="100" align="center"></el-table-column>
				<el-table-column prop="coupon_value" label="优惠金额" width="100" align="center"></el-table-column>
				<el-table-column prop="settlementamount" label="结算金额" width="100" align="center"></el-table-column>
				<el-table-column prop="business_offprice" label="商家优惠价" width="100" align="center"></el-table-column>
				<el-table-column prop="stallname" label="商家名称" width="150" align="center"></el-table-column>
				<el-table-column prop="platformdiff" label="平台差价" width="100" align="center"></el-table-column>
				<el-table-column prop="commissionfee" label="平台手续费" width="100" align="center"></el-table-column>
				<el-table-column prop="stallpayamount" label="需付商家金额" width="120" align="center"></el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="100" align="center">
					<template slot-scope="scope">
						<a @click="copyOrderNo(scope.$index, scope.row)" title="复制单号" data-clipboard-text="textToCopy"
							style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-dish">复制单号</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]"
				:current-page="param.page" :page-size="param.pagenum" :total="orderTotal"
				@size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs'
import clipboard from 'clipboard'
import { nfsprefix, baseUrl } from '/static/baseUrl.js'
import { queryOrderSaleList, queryPlatformSaleStat, exportPlatformStatDetail } from '/static/apiUrl.js'
export default {
	name: 'OrderSaleList',
	data() {
		return {
			detailShow: false,
			editok: false,
			detailTitle: '订单详情',
			selectorderno: '',
			searchInfo: {
				begintime: '',
				endtime: '',
				timevalue: '1',
			},
			param: {
				page: 1,
				pagenum: 10,
			},
			timeList: [
				{
					label: '全部日期',
					value: '0',
				},
				{
					label: '今天',
					value: '1',
				},
				{
					label: '昨天',
					value: '2',
				},
				{
					label: '本周',
					value: '3',
				},
				{
					label: '本月',
					value: '4',
				},
				{
					label: '本季度',
					value: '5',
				},
				{
					label: '本年',
					value: '6',
				},
			],
			orderTotal: 0,
			recordList: [],
			statinfo: {
				begintime: '',
				endtime: '',
				order_count: 0,
				refund_count: 0,
				coupon_count: 0,
				coupon_value: 0,
				total_amount: 0,
				is_wechat_deduction: false,
				wechat_deduction: 0,
				platform_deduction: 0,
				total_income: 0,
				total_packprice: 0,
				total_delivery_fee: 0,
				total_open_cabinet_fee: 0,
				total_platformdiff: 0,
				total_stallpayamount: 0,
				total_settlementamount: 0,
				hot_sale_foods: [],
			},
		}
	},
	mounted() {
		this.initData()
		this.queryOrder()
	},
	components: {
	},
	methods: {
		getBeginDate() {
			let now = new Date();
			let year = now.getFullYear();
			let month = now.getMonth();
			let day = now.getDate();
			return year + "-" + month + "-" + day;
		},
		getCurrentDate() {
			let now = new Date();
			let year = now.getFullYear();
			let month = now.getMonth() + 1;
			let day = now.getDate();
			return year + "-" + month + "-" + day;
		},
		copyOrderNo(idx, row) {
			console.log(idx, row)
			this.selectorderno = row.orderno
			clipboard.copy(row.orderno);
			this.$message({ type: 'success', message: '复制成功!' });
		},
		handleSizeChange(val) {
			console.log(val);
			this.param.pagenum = val;
			this.queryOrder()
		},
		handleCurrentChange(val) {
			console.log(val);
			this.param.page = val
			this.queryOrder()
		},
		initData() {
			// queryStallLists({
			// 	state: "normal",
			// 	offset: 0,
			// 	limit: 100
			// }).then(res => {
			// 	console.log(res)
			// 	if (0 == res.code) {
			// 		this.stallList = res.data.data
			// 	}
			// })
		},
		searchData() {
			this.param.page = 1
			this.recordList = []
			this.statinfo.begintime = ''
			this.statinfo.endtime = ''
			this.statinfo.order_count = 0
			this.statinfo.refund_count = 0
			this.statinfo.coupon_count = 0
			this.statinfo.coupon_value = 0
			this.statinfo.total_amount = 0
			this.statinfo.is_wechat_deduction = false
			this.statinfo.wechat_deduction = 0
			this.statinfo.platform_deduction = 0
			this.statinfo.total_income = 0
			this.statinfo.total_packprice = 0
			this.statinfo.total_delivery_fee = 0
			this.statinfo.total_open_cabinet_fee = 0
			this.statinfo.total_platformdiff = 0
			this.statinfo.total_stallpayamount = 0
			this.statinfo.total_settlementamount = 0
			this.statinfo.hot_sale_foods = []
			this.queryOrder()
		},
		clearSearch() {
			this.searchInfo.begintime = ''
			this.searchInfo.endtime = ''
			this.searchInfo.timevalue = '1'
			this.param.page = 1
			this.queryOrder()
		},
		getOrderStateName(st) {
			if (st == 'notpay') {
				return '待支付'
			} else if (st == 'notdining') {
				return '待出餐'
			} else if (st == 'notsend') {
				return '待配送'
			} else if (st == 'sending') {
				return '配送中'
			} else if (st == 'sended') {
				return '待取餐'
			} else if (st == 'pickuped') {
				return '待评论'
			} else if (st == 'overed') {
				return '已结束'
			} else if (st == 'cancel') {
				return '已取消'
			}
			return ''
		},
		queryOrder() {
			this.recordList = []
			queryOrderSaleList({
				begintime: this.searchInfo.begintime,
				endtime: this.searchInfo.endtime,
				timevalue: this.searchInfo.timevalue,
				offset: (this.param.page - 1) * this.param.pagenum,
				limit: this.param.pagenum
			}).then(res => {
				console.log(res)
				if (0 == res.code) {
					this.orderTotal = res.data.total
					res.data.data.forEach((item) => {
						this.recordList.push({
							orderno: item.stallsorders_orderno,
							ordertime: dayjs(item.stallsorders_ordertime).format('YYYY-MM-DD'),
							foodname: item.service_foodname,
							platform_offprice: item.platform_offprice.toFixed(2),
							isrefund: item.stallsorders_isrefund == "y" ? "是" : "否",
							refundreason: item.service_refundreason,
							refundtime: item.stallsorders_isrefund == "y" ? dayjs(item.service_refundtime).format('YYYY-MM-DD') : "",
							refundamount: item.service_refundamount.toFixed(2),
							coupon_category: item.coupon_category,
							coupon_value: item.coupon_value.toFixed(2),
							settlementamount: item.service_settlementamount.toFixed(2),
							business_offprice: item.business_offprice.toFixed(2),
							stallname: item.service_stallname,
							platformdiff: item.stallsorders_platformdiff.toFixed(2),
							commissionfee: item.stallsorders_commissionfee.toFixed(2),
							stallpayamount: item.stallsorders_stallpayamount.toFixed(2),
							state: item.stallsorders_state,
							statename: this.getOrderStateName(item.stallsorders_state),
						})
					})
				}
			})

			queryPlatformSaleStat({
				begintime: this.searchInfo.begintime,
				endtime: this.searchInfo.endtime,
				timevalue: this.searchInfo.timevalue,
			}).then(res => {
				console.log(res)
				if (0 == res.code) {
					this.statinfo.begintime = res.data.begintime
					this.statinfo.endtime = res.data.endtime
					this.statinfo.order_count = res.data.order_count
					this.statinfo.refund_count = res.data.refund_count
					this.statinfo.coupon_count = res.data.coupon_count
					this.statinfo.coupon_value = res.data.coupon_value
					this.statinfo.total_platform_amount = res.data.total_platform_amount
					this.statinfo.total_business_amount = res.data.total_business_amount
					this.statinfo.total_payed_amount = res.data.total_payed_amount
					this.statinfo.is_wechat_deduction = res.data.is_wechat_deduction
					this.statinfo.platform_deduction_ratio = res.data.platform_deduction_ratio
					this.statinfo.wechat_deduction_ratio = res.data.wechat_deduction_ratio
					this.statinfo.wechat_deduction = res.data.wechat_deduction
					this.statinfo.platform_deduction = res.data.platform_deduction
					this.statinfo.total_business_refund_amount = res.data.total_business_refund_amount
					this.statinfo.total_platform_refund_amount = res.data.total_platform_refund_amount
					this.statinfo.total_income = res.data.total_income
					this.statinfo.total_packprice = res.data.total_packprice
					this.statinfo.total_delivery_fee = res.data.total_delivery_fee
					this.statinfo.total_open_cabinet_fee = res.data.total_open_cabinet_fee
					this.statinfo.total_platformdiff = res.data.total_platformdiff
					this.statinfo.total_stallpayamount = res.data.total_stallpayamount
					this.statinfo.total_settlementamount = res.data.total_settlementamount
					this.statinfo.hot_sale_foods = res.data.hot_sale_foods
				}
			})
		},
		exportOrders() {
			exportPlatformStatDetail({
				begintime: this.searchInfo.begintime,
				endtime: this.searchInfo.endtime,
				timevalue: this.searchInfo.timevalue,
			}).then(res => {
				if (0 == res.code) {
					this.downLoad(res.data);
				} else {
					this.$message({ type: 'error', message: res.msg });
				}
			})
		},
		downLoad(filename) {
			var a = document.createElement("a");
			a.href = baseUrl + nfsprefix + "/report/excel/" + filename;
			// a.target = "_blank";
			a.download = filename;
			a.style.display = "none";
			document.body.appendChild(a);
			a.click();
			a.remove();
		},
		goShopUserDetail(idx, row) {
			this.detailTitle = '订单详情'
			console.log(idx, row)
			this.selectorderno = row.orderno
			this.detailShow = true
		},
	},
	beforeDestroy() {

	},
}
</script>

<style scoped></style>